const getIds = (list) => {
	const idList = [];
	list.forEach(({id = null, teamId = null, selected, teamList}) => {
		if (selected) idList.push(id || teamId);
		if (teamList?.length > 0) {
			const childIds = getIds(teamList);
			if (childIds?.length > 0) idList.push(...childIds);
		}
	});
	return idList;
};

export default (nestedList) => getIds(nestedList);
